export function middleEllipsis(str: string, startChars = 15, endChars = 15, ellipsis = "..."): string {
    if (str.length <= startChars + endChars) {
        return str;
    }
    const start = str.substring(0, startChars);
    const end = str.substring(str.length - endChars);
    return `${start}${ellipsis}${end}`;
}
